import axios from 'axios';
import { handleRequest } from 'helpers/api';

const COUPON_URL = `${process.env.REACT_APP_API_URL}/coupon`;

const couponsApi = axios.create({
  baseURL: COUPON_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

export interface AddCoupon {
  code: string;
  discountType: string;
  value: number; // now a number
  validFrom?: string;
  validTo?: string;
  usageLimit?: number;
  usedCount?: number; // filled by backend or zero on create
  appliesTo: string;
  targetIds: string[]; // array
  isActive: boolean;
  vendorId?: string; // optional – fill in on the server or here
}

export interface VendorCoupons {
  _id: string;
  code: string;
  appliesTo: string;
  discountType: string;
  value: number;
  usageLimit: number;
  usedCount: number;
  validFrom: string;
  validTo: string;
  targetIds: string[];
  isActive: boolean;
}

export const addCoupon = async (coupon: AddCoupon) => {
  return handleRequest(couponsApi.post('/add-coupon', coupon));
};

export const editCoupon = async (coupon: AddCoupon, couponId: string) => {
  return handleRequest(couponsApi.post(`/edit-coupon/${couponId}`, coupon));
};

export const getAllCouponByVendor = async (vendorId: string) => {
  return handleRequest(
    couponsApi.get<VendorCoupons[]>(`all-coupon-by-vendor/${vendorId}`)
  );
};

export const getCouponById = async (id: string) => {
  return handleRequest(couponsApi.get<VendorCoupons>(`/coupon-by-id/${id}`));
};

export const getCouponByApppliesId = async (id: string) => {
  return handleRequest(
    couponsApi.get<VendorCoupons[]>(`/coupon-by-appliesId/${id}`)
  );
};
